import React from 'react';

const SvgLinkContainer = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 28" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle cx={14} cy={14} r={14} fill="currentColor" />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M10.182 11C8.425 11 7 12.343 7 14s1.425 3 3.182 3h2.545v-1.2h-2.545c-1.055 0-1.91-.806-1.91-1.8s.855-1.8 1.91-1.8h2.545V11h-2.545zm5.09 0v1.2h2.546c1.055 0 1.91.806 1.91 1.8s-.855 1.8-1.91 1.8h-2.545V17h2.545C19.575 17 21 15.657 21 14s-1.425-3-3.182-3h-2.545zm-4.454 2.4v1.2h6.364v-1.2h-6.364z"
      />
    </g>
  </svg>
);

export default SvgLinkContainer;
